/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VwbDataCollectionEntry
 */
export interface VwbDataCollectionEntry {
    /**
     * Display name of the data collection workspace
     * @type {string}
     * @memberof VwbDataCollectionEntry
     */
    workspaceDisplayName?: string;
    /**
     * User-facing ID of the data collection workspace
     * @type {string}
     * @memberof VwbDataCollectionEntry
     */
    workspaceUserFacingId?: string;
    /**
     * Description of the data collection workspace
     * @type {string}
     * @memberof VwbDataCollectionEntry
     */
    workspaceDescription?: string;
    /**
     * Creation timestamp of the workspace
     * @type {string}
     * @memberof VwbDataCollectionEntry
     */
    createdDate?: string;
    /**
     * GCP project ID
     * @type {string}
     * @memberof VwbDataCollectionEntry
     */
    gcpProjectId?: string;
    /**
     * Pod ID of the workspace
     * @type {string}
     * @memberof VwbDataCollectionEntry
     */
    podId?: string;
    /**
     * Display name of the resource
     * @type {string}
     * @memberof VwbDataCollectionEntry
     */
    resourceDisplayName?: string;
    /**
     * Name of the resource
     * @type {string}
     * @memberof VwbDataCollectionEntry
     */
    resourceName?: string;
    /**
     * ID of the resource
     * @type {string}
     * @memberof VwbDataCollectionEntry
     */
    resourceId?: string;
    /**
     * Version (folder display name) of the resource
     * @type {string}
     * @memberof VwbDataCollectionEntry
     */
    version?: string;
    /**
     * Type of the resource
     * @type {string}
     * @memberof VwbDataCollectionEntry
     */
    resourceType?: string;
}

/**
 * Check if a given object implements the VwbDataCollectionEntry interface.
 */
export function instanceOfVwbDataCollectionEntry(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VwbDataCollectionEntryFromJSON(json: any): VwbDataCollectionEntry {
    return VwbDataCollectionEntryFromJSONTyped(json, false);
}

export function VwbDataCollectionEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): VwbDataCollectionEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'workspaceDisplayName': !exists(json, 'workspaceDisplayName') ? undefined : json['workspaceDisplayName'],
        'workspaceUserFacingId': !exists(json, 'workspaceUserFacingId') ? undefined : json['workspaceUserFacingId'],
        'workspaceDescription': !exists(json, 'workspaceDescription') ? undefined : json['workspaceDescription'],
        'createdDate': !exists(json, 'createdDate') ? undefined : json['createdDate'],
        'gcpProjectId': !exists(json, 'gcpProjectId') ? undefined : json['gcpProjectId'],
        'podId': !exists(json, 'podId') ? undefined : json['podId'],
        'resourceDisplayName': !exists(json, 'resourceDisplayName') ? undefined : json['resourceDisplayName'],
        'resourceName': !exists(json, 'resourceName') ? undefined : json['resourceName'],
        'resourceId': !exists(json, 'resourceId') ? undefined : json['resourceId'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'resourceType': !exists(json, 'resourceType') ? undefined : json['resourceType'],
    };
}

export function VwbDataCollectionEntryToJSON(value?: VwbDataCollectionEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'workspaceDisplayName': value.workspaceDisplayName,
        'workspaceUserFacingId': value.workspaceUserFacingId,
        'workspaceDescription': value.workspaceDescription,
        'createdDate': value.createdDate,
        'gcpProjectId': value.gcpProjectId,
        'podId': value.podId,
        'resourceDisplayName': value.resourceDisplayName,
        'resourceName': value.resourceName,
        'resourceId': value.resourceId,
        'version': value.version,
        'resourceType': value.resourceType,
    };
}

